import { Modal } from "antd";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../../../components/Button";
import {
  ButtonContainer,
  CancelButton,
  confirmModalCss,
  ContentContainer,
} from "./ArchiveSpirometryConfirmationModal.styles";

interface IArchiveSpirometryConfirmationModalProps {
  archiveMeasurementValue?: number;
  unit?: string;
  time?: string;
  isLoading: boolean;
  handleConfirmModalClose: (confirm: boolean) => Promise<void>;
}

export function ArchiveSpirometryConfirmationModal({
  archiveMeasurementValue,
  handleConfirmModalClose,
  isLoading,
  unit,
  time,
}: IArchiveSpirometryConfirmationModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      title={t("patientPage_measurementModal_archiveModal_title")}
      open
      zIndex={3001}
      footer={null}
      width={610}
      height={400}
      className={confirmModalCss()}
      centered
      destroyOnClose
      closeIcon={false}
    >
      <ContentContainer>
        <p
          style={{
            padding: "12px 0 0 0",
            fontWeight: "400",
            color: "#939393",
            marginLeft: "5px",
          }}
        >
          {t("patientPage_measurementModal_archiveModal_spirometryBody", {
            value: `${archiveMeasurementValue} ${unit}`,
            time,
          })}
        </p>
        <ButtonContainer>
          <Button
            label={t("patientPage_measurementModal_archiveModal_archive")}
            type="button"
            onClick={() => handleConfirmModalClose(true)}
            isLoading={isLoading}
          />

          <CancelButton isModal onClick={() => handleConfirmModalClose(false)}>
            {t("common_cancel")}
          </CancelButton>
        </ButtonContainer>
      </ContentContainer>
    </Modal>
  );
}
